import { Button, Modal, Tooltip } from "flowbite-react";
import { DataTable } from "../../../components/data-table";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { GETCOMPANIES_REQ } from "../../../actions";
import { Popup } from "../../../components/pop-up";
import * as actions from "../../../actions";
import { COWORKERCOMPANY_RESPONSE } from "../../../constants/action_types";
import { FlatButton } from "../../../components/buttons";

export function AddCoworkerCompany({ coworkerDetails, companyDetasils }) {
  const dispatch = useDispatch();
  const urlParams = useRef({});

  const customersList = useSelector((state) => state?.company?.list);
  const coworkersUpdated = useSelector(
    (state) => state?.coworker?.update_response
  );

  const [modalState, setModalState] = useState();
  const [selected, setSelected] = useState([]);
  const [confirmModal, setConfirmModal] = useState();

  useEffect(() => {
    if (coworkersUpdated?.type === COWORKERCOMPANY_RESPONSE) {
      setModalState();
      setSelected([]);
      dispatch(actions.RESET_STATE("company.list"));
    }
  }, [coworkersUpdated]);

  const columns = [
    {
      name: "#",
      key: "company_id",
      width: 16,
    },
    {
      name: "Customer Name",
      key: "company_name",
    },
    { name: "Company Email", key: "company_email" },
    { name: "Country", key: "company_country" },
    { name: "Created at", key: "created_at", type: "date" },
    { name: "Total users", key: "total_users" },
    {
      name: "Status",
      key: "is_active",
      disableSort: true,
      formatText: (isActive) => (isActive ? "Active" : "Inactive"),
      processClassName: (isActive) =>
        isActive ? "text-green-500 font-medium" : "text-red-500 font-medium",
    },
  ];

  const handleFetch = async (params) => {
    if (params) {
      urlParams.current.page = params.page;
      urlParams.current.count = params.pageLimit;
      urlParams.current.sort_by = params.sortBy;
      urlParams.current.sort = params.sortDir;
      urlParams.current["filter.keyword"] = params.keyword;
    }
    dispatch(GETCOMPANIES_REQ(urlParams.current));
  };

  const handleCompanyAccess = () => {
    setConfirmModal();
    if (coworkerDetails?.coworker_uid) {
      dispatch(
        actions.COWORKERCOMPANY_REQ({
          coworker_uid: coworkerDetails.coworker_uid,
          company_uids: selected?.map((_c) => _c.company_uid) || [],
        })
      );
    }
  };

  return (
    <>
      <Tooltip
        className="whitespace-nowrap"
        content={
          coworkerDetails?.role === "ADMIN"
            ? "Admins have global access"
            : "Give company access to coworker"
        }
      >
        <FlatButton
          onClick={() => {
            setModalState("pop-up");
          }}
          disabled={coworkerDetails?.role === "ADMIN"}
        >
          Add Company
        </FlatButton>
      </Tooltip>
      <Modal
        popup
        show={modalState}
        className="[&>div>div]:p-3 [&>div>div]:pr-0"
        size="5xl"
        onClose={() => {
          // setSelected([]);
          setModalState();
        }}
      >
        {/* <Modal.Header>
          <h3 className="px-3 pt-3">Choose Companies</h3>
        </Modal.Header> */}
        <Modal.Body className="px-2 py-0">
          <div className="min-h-50 [&>div]:p-0">
            <DataTable
              name="Choose Companies"
              columns={columns}
              indexField="company_uid"
              remote={true}
              handleFetch={handleFetch}
              data={customersList?.data}
              totalCount={customersList?.totalCount}
              toolbar={{
                search: { enable: true, placeholder: "Search Companies" },
                hideCount: true,
              }}
              rowSelection={{
                enable: true,
                type: "selection",
                position: "end",
                multi: true,
                onRowSelect: ({ selectedRows }) => {
                  setSelected(selectedRows);
                },
              }}
              footer={{
                paginator: { enable: true, limits: [10], placement: "start" },
                customActions: (
                  <div className=" justify-self-end flex flex-row gap-x-6">
                    <FlatButton
                      size="xl"
                      appearance="secondary"
                      id="cancel-button"
                      onClick={() => {
                        setSelected([]);
                        setModalState(undefined);
                      }}
                    >
                      Cancel
                    </FlatButton>
                    <FlatButton
                      size="xl"
                      disabled={selected?.length === 0}
                      appearance="primary"
                      // className={confirmClass || ""}
                      id="confirm-button"
                      onClick={() => {
                        setConfirmModal("pop-up");
                      }}
                    >
                      Confirm
                    </FlatButton>
                  </div>
                ),
              }}
            />
          </div>
        </Modal.Body>
      </Modal>
      <Popup
        modalState={[confirmModal, setConfirmModal]}
        onConfirm={handleCompanyAccess}
        content={
          <>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              stroke="currentColor"
              className="mx-auto mb-4 h-14 w-14 text-gray-400 dark:text-gray-200"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M12 9v3.75m9-.75a9 9 0 11-18 0 9 9 0 0118 0zm-9 3.75h.008v.008H12v-.008z"
              />
            </svg>
            <h3 className="mb-5 text-lg font-normal text-gray-500 dark:text-gray-400">
              Are you sure you want to provide access to{" "}
              {coworkerDetails?.fullName} for the
              <span className="inline-block ml-3">
                <Tooltip
                  placement="right-start"
                  content={
                    <ul className="text-left whitespace-nowrap">
                      {selected?.reduce((tooltip, company) => {
                        tooltip.push(
                          <li className="mb-2">{company.company_name}</li>
                        );
                        return tooltip;
                      }, [])}
                    </ul>
                  }
                >
                  <p className="text-blue-500 font-medium underline cursor-pointer">
                    selected {selected?.length > 1 ? "companies" : "company"}
                  </p>
                </Tooltip>
              </span>
              ?
            </h3>
          </>
        }
      />
    </>
  );
}
